import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; // 👈 IMPORTANTE
import api from "../api/axios";
import "../styles/Forgottpassword.css";

export default function ForgotPasswordPage() {
  const { t } = useTranslation<"translation">();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ?? t("forgotPassword.error") ?? "Error al enviar la solicitud";
      setError(msg);
    }
  };

  if (sent) {
    return (
      <div className="login-container">
        <div className="image-container" />
        <div className="cuadrologin">
          <div className="form-container">
            <div className="login-form text-center space-y-4">
              <h2 className="title">{t("forgotPassword.title")}</h2>
              <p className="success-message">{t("forgotPassword.sent")}</p>
              <Link to="/login" className="submit-button inline-block">
                {t("forgotPassword.backToLogin")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      {error && (
        <div
          role="alert"
          aria-live="assertive"
          style={{
            position: "fixed",
            top: 10,
            left: "40%",
            transform: "translateX(-50%)",
            padding: "10px 14px",
            color: "#fff",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            zIndex: 9999,
            fontWeight: 600,
            maxWidth: "90%",
            textAlign: "center",
          }}
        >
          {error}
        </div>
      )}

      <div className="image-container" />
      <div className="cuadrologin">
        <div className="form-container">
          <form onSubmit={submit} className="login-form" noValidate>
            <div className="logo-wrapper" />
            <h2 className="title">{t("forgotPassword.title")}</h2>
            <div className="parrafo-contraseña">
              <p>
                Para reestablecer tu contraseña, introduce el email que utilizaste para crear tu
                cuenta. Te enviaremos un enlace para que puedas recuperar tu cuenta al siguiente
                correo electrónico:
              </p>
            </div>
            <input
              className="input-field"
              placeholder={t<string>("forgotPassword.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              type="email"
              required
            />

            <button type="submit" className="submit-button">
              {t("forgotPassword.btn")}
            </button>

            <div className="forgot-password-wrapper">
              <Link to="/login" className="forgot-password-link">
                {t("forgotPassword.backToLogin")}
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
